import React, { Component } from 'react';
import TableRowSolicitudes from './TableRowSolicitudes';
import { solicitudes } from '../../NuevaSolicitudCuenta/components/ObjetoFer';

class Table extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openConfirmador: 0,
            eliminarSolicitud: false
        }
        this.toggleModalConfirmador = this.toggleModalConfirmador.bind(this);
    }

    toggleModalConfirmador(id, eliminar) {
        if (this.state.openConfirmador == 0) {
            this.setState({ openConfirmador: id, eliminarSolicitud: eliminar })
        } else if (this.state.openConfirmador == id) {
            this.setState({ openConfirmador: 0, eliminarSolicitud: false })
        } else if (this.state.openConfirmador != 0 && this.state.openConfirmador != id) {
            this.setState({ openConfirmador: id, eliminarSolicitud: eliminar })
        }
    }

    createTable(solicitudes, tarjetas) {
        //AGREGO UNA PROPIEDAD "TARJETAS" PARA CADA SOLICITUD QUE ES UN ARREGLO VACÍO, YA QUE LAS TARJETAS VIENEN EN UN ARREGLO SEPARADO DESDE LA BASE DE DATOS
        solicitudes.map(solicitud => solicitud.Tarjetas = []);
        //MAPEO LAS TARJETAS Y LAS AGREGO A LA SOLICITUD CORRESPONDIENTE
        tarjetas.map(tarjeta => solicitudes.map(sol => {
            if (sol.solicitudId == tarjeta.SolicitudId && sol.SolicitudTipoId != 3) {
                sol.Tarjetas.push(tarjeta)
            } else if (sol.solicitudId == tarjeta.SolicitudId && sol.SolicitudTipoId == 3) {
                //cuando la solicitud es tipo 3 se deben agregar solo las tarjetas correspondientes a la solicitud y no a la cuenta operativa
                if (tarjeta.TarjetaCreditoEstadoId != 3) sol.Tarjetas.push(tarjeta)
            }
        }))
        //SE DIVIDEN EN ARREGLOS SEPARADOS POR ADMINISTRADORA PARA GENERAR LAS CELDAS COMBINADAS DE ACUERDO A MARCA
        let visa = [];
        let cabal = [];
        let master = [];

        solicitudes.map(sol => {
            if (sol.marcaId == 1) visa.push(sol)
            if (sol.marcaId == 2) cabal.push(sol)
            if (sol.marcaId == 3) master.push(sol)
        })

        // SE LE ASIGNA UNA POSICION "CERO" A CADA ADMINISTRADORA Y EL LARGO DEL ARREGLO (CANTIDAD DE SOLICITUDES EN LA ADMINISTRADORA)
        // PARA PASARLE COMO PROPIEDAD AL COMPONENTE QUE VA A HACER LOS ROWSPAN DE ACUERDO A ADMINISTRADORA.
        if (visa.length > 0) visa.map((s, indice) => { s.primero = indice == 0; s.largo = visa.length })
        if (cabal.length > 0) cabal.map((s2, indice2) => { s2.primero = indice2 == 0; s2.largo = cabal.length })
        if (master.length > 0) master.map((s3, indice3) => { s3.primero = indice3 == 0; s3.largo = master.length })

        //SE VUELVEN A JUNTAR PARA PASAR UN SOLO ARREGLO
        let ambas = visa.concat(cabal)
        ambas = ambas.concat(master)

        return (
            ambas.map((solicitud) => {
                if (solicitud.primero) {
                    return <TableRowSolicitudes
                        key={solicitud.solicitudId}
                        rowS={solicitud.largo}
                        solicitud={solicitud}
                        modalConfirmadorId={this.state.openConfirmador}
                        toggleModalConfirmador={this.toggleModalConfirmador}
                        cambiarEstadoSolicitud={this.props.cambiarEstadoSolicitud}
                        modificarSolicitud={this.props.modificarSolicitud}
                        eliminaSolicitud={this.state.eliminarSolicitud}
                        empresas={this.props.tarjetas.empresas} />
                } else {
                    return <TableRowSolicitudes
                        key={solicitud.solicitudId}
                        rowS={""}
                        solicitud={solicitud}
                        modalConfirmadorId={this.state.openConfirmador}
                        toggleModalConfirmador={this.toggleModalConfirmador}
                        cambiarEstadoSolicitud={this.props.cambiarEstadoSolicitud}
                        modificarSolicitud={this.props.modificarSolicitud}
                        eliminaSolicitud={this.state.eliminarSolicitud}
                        empresas={this.props.tarjetas.empresas} />
                }
            })


        )

    }

    render() {

        let crearTabla = undefined;
        let me = this;

        if (this.props.solicitudesCliente != undefined && this.props.solicitudesCliente.length > 0) {
            crearTabla = me.createTable(this.props.solicitudesCliente, this.props.integrantes)
        }

        return (
            <div id={this.props.id} className={this.props.className}>
                <div className="row top-separator-xs">
                    <div className="col-md-12">
                    <h1 style={{ fontSize: '29px' }}>Solicitudes en curso</h1><br/>
                        <table className="table clickeable-row-table">
                            <thead>
                                <tr>
                                    <th className="rowBordersVistaClienteNoSides"></th>
                                    <th className="rowBordersVistaClienteNoSides"></th>
                                    <th className="rowBordersVistaClienteNoSides">Nº SOL.</th>
                                    <th className="rowBordersVistaClienteNoSides">TIPO</th>
                                    <th className="rowBordersVistaClienteNoSides">EMPRESA</th>
                                    <th className="rowBordersVistaClienteNoSides">CUENTA</th>
                                    <th className="rowBordersVistaClienteNoSides">INTEGRANTES</th>
                                    <th className="rowBordersVistaClienteNoSides">ESTADO</th>
                                    <th className="rowBordersVistaClienteNoSides">F. ESTADO</th>
                                    <th className="hide">ACCIONES</th>
                                </tr>
                            </thead>
                            <tbody>
                                {crearTabla}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default Table;